import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Home from "../components/Layouts/Home";
import SingleProduct from "../components/search/product";
import { SubmitButton } from "../components/shared/input";
import { SearchLoading } from "../components/shared/loading";
import { GET, POST } from "../utils/requests";
import { initCart } from "../utils/state";
import { wishListAction } from "../utils/utility";

const WishList = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();

  useEffect(async () => {
    setData(await GET("/wishlist"));
  }, []);

  const moveToCart = async (item) => {
    setData(data.filter((s) => s.id !== item.id));
    await wishListAction("/remove", item.id);
    await POST("/cart", {
      priceId: item.price.id,
      productId: item.id,
      quantity: 1,
    });
    initCart(dispatch);
  };

  return (
    <Home>
      <Container className="small-container">
        <div className="d-flex mt-4 mb-4 align-items-center">
          <h1 className="fs-4 text-dark fw-bold mb-0">My WishList</h1>
          <span className="text-grey fs-6 ps-3">({data?.length} items)</span>
        </div>
        <Row className="mb-5 gx-4">
          {!data ? (
            <SearchLoading count={3} sm="4 mb-5 pb-5" />
          ) : (
            data.map((x) => (
              <div className="col-md-3">
                <SingleProduct {...x} width="100%" />
                <SubmitButton
                  onClick={(_) => moveToCart(x)}
                  style={{
                    backgroundColor: "rgba(1,1,1,.07)",
                  }}
                  className={"mt-0 btn-light rounded-16"}
                  title={"Move to cart"}
                  color={"dark"}
                />
              </div>
            ))
          )}
        </Row>
      </Container>
    </Home>
  );
};

export default WishList;
